__turbopack_context__.v({
  "line": "SharpnessSideBarLines-module-scss-module__8NomLG__line",
  "lineVertical": "SharpnessSideBarLines-module-scss-module__8NomLG__lineVertical",
  "lines": "SharpnessSideBarLines-module-scss-module__8NomLG__lines",
  "root": "SharpnessSideBarLines-module-scss-module__8NomLG__root",
});
